import * as signalR from "@aspnet/signalr";
import PubSub from "../services/pubsub-service";
import * as PubSubActionType from "../services/constants";
import { ObjToParam } from "../helper/helper-api";

export const signalRFactory = {
  _connection: null,

  messageReceived(message) {
    if (process.env.NODE_ENV === "development") {
      console.log("message", message);
    }

    if (message.eventName === "ChangeRole") {
      PubSub.publish(PubSubActionType.CHANGE_ROLE, { message: message.body });
    }

    if (
      message.eventName === "ChangeProjectOwnerStarted" ||
      message.eventName === "ChangeProjectCoordinatorStarted"
    ) {
      PubSub.publish(PubSubActionType.REASSIGN_PROJECT_START, {
        message: message.body,
      });
    }

    if (
      message.eventName === "ChangeProjectOwnerFinished" ||
      message.eventName === "ChangeProjectCoordinatorFinished"
    ) {
      PubSub.publish(PubSubActionType.REASSIGN_PROJECT_FINISHED, {
        message: message.body,
      });
    }

    if (message.eventName === "UserSuspended") {
      PubSub.publish(PubSubActionType.USER_SUSPENDED, {
        message: message.body,
      });
    }

    if (message.eventName === "UserLocked") {
      PubSub.publish(PubSubActionType.USER_LOCKED, { message: message.body });
    }

    if (message.eventName === "RequestMultipleReassignManageByUserStarted") {
      PubSub.publish(PubSubActionType.REASSIGN_MULTIPLE_RFS_START, {
        message: message.body,
      });
    }

    if (message.eventName === "RequestMultipleReassignManageByUserFinished") {
      PubSub.publish(PubSubActionType.REASSIGN_MULTIPLE_RFS_FINISHED, {
        message: message.body,
      });
    }

    if (message.eventName === "WorkOrderMultipleReassignAssigneeStarted") {
      PubSub.publish(PubSubActionType.REASSIGN_MULTIPLE_WORK_ORDER_START, {
        message: message.body,
      });
    }

    if (message.eventName === "WorkOrderMultipleReassignAssigneeFinished") {
      PubSub.publish(PubSubActionType.REASSIGN_MULTIPLE_WORK_ORDER_FINISHED, {
        message: message.body,
      });
    }

    if (message.eventName === "ImportRequestForServicesProgressUpdate") {
      PubSub.publish(
        PubSubActionType.IMPORT_REQUEST_FOR_SERVICES_PROGRESS_UPDATE,
        {
          message: message.body,
        }
      );
    }

    if (message.eventName === "ImportWorkOrdersProgressUpdate") {
      PubSub.publish(PubSubActionType.IMPORT_WORK_ORDERS_PROGRESS_UPDATE, {
        message: message.body,
      });
    }

    if (message.eventName === "ImportPurchaseOrdersProgressUpdate") {
      PubSub.publish(PubSubActionType.IMPORT_PURCHASE_ORDERS_PROGRESS_UPDATE, {
        message: message.body,
      });
    }
  },

  connection(
    host,
    // params = { clientId: 'www.siteoneservicesdemo.com', clientName: 'testvu123' },
    params,
    callback,
    endpoint = "/hubs/site-one-services-bus-publish"
    // port = 7500
  ) {
    const url = `${host}${endpoint}?${ObjToParam(params)}`;

    this._connection = new signalR.HubConnectionBuilder().withUrl(url).build();

    this._connection
      .start()
      .then(() => {
        if (process.env.NODE_ENV === "development") {
          console.log("connection started");
        }
      })
      .catch((error) => {
        if (process.env.NODE_ENV === "development") {
          console.error(error.message);
        }
      });

    this._connection.on("messageReceived", (message) =>
      this.messageReceived(message)
    );

    this._connection.onclose((error) => {
      if (process.env.NODE_ENV === "development") {
        console.log("close connection", error);
      }
    });

    if (callback) {
      callback(this._connection);
    }
  },

  stop() {
    if (this._connection) {
      this._connection
        .stop()
        .then(() => {
          if (process.env.NODE_ENV === "development") {
            console.log("connection stopped");
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
    }
  },

  // reConnect: () => {}
};



// WEBPACK FOOTER //
// ./src/Factory/SignalRFactory.js